import { TypePolicies } from '@apollo/client';
import {
  AccessControlPolicy,
  useGetAccessPolicyQuery
} from 'generated/graphql';

import React, { useEffect } from 'react';

import { appFormUtil } from 'modules/common/layer00';
import _ from 'lodash';
import { useParams } from 'react-router-dom';

type IFormState = {
  create: boolean;
  update: boolean;
  delete: boolean;
  view: boolean;
};

const initialState: IFormState = {
  create: false,
  update: false,
  delete: false,
  view: false
};

export function useAccessState(entityType: keyof TypePolicies) {
  const {
    formState,
    dispatch
  } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
    }
  });

  const { data, called, loading } = useQuery(entityType);
  useEffect(() => {
    if (_.isEqual(data, formState)) {
      return () => {};
    }
    if (data && called && !loading) {
      dispatch({
        type: 'BATCH_UPDATE',
        payload: {
          ...formState,
          ...data
        }
      });
    }
    return () => {};
  }, [
    called,
    data,
    dispatch,
    formState,
    loading
  ]);

  return React.useMemo(
    () => {


      return {
        ...formState
      };
    },
    [formState]
  );
}


export interface IData extends AccessControlPolicy {}

export function useQuery(entityType: keyof TypePolicies) {
  const params = useParams();
  const tuple = useGetAccessPolicyQuery({
    variables: {
      options: {
        filter: {
          entityType: entityType.toString() ?? '',
          controllingGroupId: params.projectId
        }
      }

    }
  });

  return React.useMemo(
    () => {
      let data: IData;
      if (tuple.data?.loggedInUser?.isSuperAdmin) {
        data = {
          create: true,
          update: true,
          delete: true,
          view: true
        };
      } else {

        data = {
          create: tuple.data?.entityAccessPolicy.create ?? false,
          update: tuple.data?.entityAccessPolicy.update ?? false,
          delete: tuple.data?.entityAccessPolicy.delete ?? false,
          view: tuple.data?.entityAccessPolicy.view ?? false
        };
      }
      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



